<template>
    <div class="upload-picture-modal">
        <b-modal
            id="file-preview-popup"
            ref="modal"
            title="File Preview"
            size="md"
            ok-title="Close"
            ok-variant="primary"
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="document-preview-section">
                <div class="preview-video">
                    <authenticated-image
                        :customer-details="customerDetails"
                    ></authenticated-image>
                </div>
            </div>
            <template v-slot:modal-footer>
                <div class="w-100">
                    <b-button
                        variant="primary"
                        size="sm"
                        @click="
                            downloadFile(customerDetails.lastReview.attachment)
                        "
                    >
                        Download File
                    </b-button>
                    <b-button variant="link" size="sm" @click="closeModal()">
                        Close
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AuthenticatedImage from '@/components/AuthenticatedImage.vue'
import request from '@/utils/request'

export default {
    // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        AuthenticatedImage,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        item: {
            type: Object,
            default: null,
        },
        customerDetails: {
            type: Object,
            default: null,
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            show: false,
            showPageLoader: true,
        }
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    methods: {
        getLastReviewImageFile(customerDetails) {
            if (
                customerDetails.lastReview.attachment &&
                customerDetails.lastReview &&
                customerDetails
            ) {
                return `customers/${customerDetails.lastReview.attachment}`
            }
        }, // End of getLastReviewImageFile() method

        closeModal() {
            this.$refs.modal.hide()
        }, // End of closeModal() method

        forceFileDownload(response, fileName) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', fileName) //or any other extension
            document.body.appendChild(link)
            link.click()
        }, // End of forceFileDownload() method

        async downloadFile(fileName) {
            let fileUrl = 'customers/' + fileName
            try {
                let response = await request({
                    url: `/files/${fileUrl}`,
                    responseType: 'arraybuffer',
                })
                this.forceFileDownload(response, fileName)
            } catch (err) {
                //console.log('Error occured: ', err)
            }
        }, // End of downloadFile() method
    }, // End of Component > methods
}
</script>
